import { FC, useEffect, useState, useRef } from 'react'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import { KTCard, KTCardBody } from '../../../../_metronic/helpers'
import { UsersListPagination } from '../../../modules/apps/user-management/users-list/components/pagination/UsersListPagination'
import plusIcon from '../../../../_metronic/images/smlplus.svg'
import { CreateSalesChannelModal } from './CreateSalesChannelModal'
import SearchComponent from '../SearchComponent'
import { urlPath } from '../../../../utils/GlobalConstants'
import {
  GET_SALES_CHANNEL_LIST,
  DELETE_SALES_CHANNELS,
  UPDATE_SALES_CHANNEL_STATUS,
  GET_CLIENT_ALLOWED_COMPONENTS,
} from '../../../../utils/GraphQLAPI'
import { useLazyQuery, useMutation } from '@apollo/client'
import { Dropdown, Spinner } from 'react-bootstrap'
import DownloadCsv from '../../Download/DownloadCsv'
import moment from 'moment'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import SwalThinkingImage from '../../../../_metronic/images/swal_thinking_face.svg'
import { alert } from '../../../../utils/helper'
import { GLOBAL_CONSTANTS, timeFormat } from '../../../../utils/GlobalConstants'
import { useLocalStorage } from '../../../../utils/useLocalStorage'
const MySwal = withReactContent(Swal)

const SalesChannelList: FC = () => {
  const { setItem, getItem } = useLocalStorage()
  const [total, setTotal] = useState<number>()
  const [showCreateAppModal, setShowCreateAppModal] = useState<boolean>(false)
  const [createModal, setCreateModal] = useState<string>('create')
  const [salesChannelId, setSalesChannelId] = useState<any>()
  const [salesChannel, setSalesChannel] = useState<any>()
  const [filterTempOptions, setFilterTempOptions] = useState<any>()
  const [downloadData, setDownloadData] = useState<any>([])
  const csvRef = useRef<any>(null)
  const [removeScId, setRemoveScId] = useState<any>()
  const [activate, setActivate] = useState<any>({ id: '', isActive: '' })
  const [isSolarProduct, setIsSolarPRoduct] = useState<any>(false)
  const location = useLocation()
  const [pageNo, updatePageNo] = useState<any>(() => {
    if (location.pathname.includes(urlPath.salesChannel)) {
      const savedPage = getItem(urlPath.salesChannel)
      return savedPage ? parseInt(savedPage) - 1 : 0
    }
    return 0
  })
  //SC List CSV Download
  const csvHeaders = [
    { label: 'Channels Name', key: 'salesChannelName' },
    { label: 'Admin Email ID', key: 'salesAdminEmailId' },
    { label: '# Prod.assigned', key: 'noOfProductsAssigned' },
    { label: '# Agents', key: 'noOfAgents' },
    { label: 'Sign In', key: 'salesAdminSignInTime' },
    { label: 'Out Time', key: 'salesAdminSignOutTime' },
    { label: 'Status', key: 'isActive' },
  ]

  const [filterOptions, setFilterOptions] = useState<any>({
    searchText: '',
    page: 1,
    perPage: 10,
  })

  const navigate = useNavigate()
  const getUrlParams = useParams()

  const updateRowsPerPage = (value: any) => {
    setFilterOptions((prevOptions: any) => {
      return { ...prevOptions, perPage: value, page: pageNo + 1 }
    })
  }

  const [getClientAllowedComponents] = useLazyQuery(GET_CLIENT_ALLOWED_COMPONENTS, {
    onCompleted: (data) => {
      setIsSolarPRoduct(data?.getClientAllowedComponents.includes('solarProductSetup'))
    },
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
  })
  useEffect(() => {
    if (location.pathname.includes(urlPath.salesChannel)) {
      setItem(pageNo + 1, urlPath.salesChannel)
    }
  }, [pageNo, location.pathname])
  useEffect(() => {
    getClientAllowedComponents()
  }, [])

  const openModal = (event: any, editId: any) => {
    setShowCreateAppModal(true)
    if (editId) {
      setCreateModal('edit')
      setSalesChannelId(editId)
    } else {
      setCreateModal('create')
      setSalesChannelId('')
    }
  }

  const handleCloseModal = () => {
    refetch()
    setShowCreateAppModal(false)
    setSalesChannelId('')
  }

  const refreshCustomerList = () => {
    refetch()
  }

  // List API
  const [getQcListByTeamAdmin, { loading, refetch }] = useLazyQuery(GET_SALES_CHANNEL_LIST, {
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
    variables: {
      salesChannelListInput: filterOptions,
    },
    onCompleted: (data) => {
      setSalesChannel(data.getSalesChannelList.salesChannels)
      setTotal(data.getSalesChannelList.totalCount)
    },
    onError: (err) => console.log('error', err),
  })

  useEffect(() => {
    getQcListByTeamAdmin()
  }, [filterOptions])

  //SC List CSV Download API Hit
  const [getQcCSVListByTeamAdmin, { loading: reload }] = useLazyQuery(GET_SALES_CHANNEL_LIST, {
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
    variables: {
      salesChannelListInput: filterTempOptions,
    },
    onCompleted: (data) => {
      setDownloadData(
        data.getSalesChannelList.salesChannels.map(
          (item: {
            isActive: any
            salesAdminSignInTime: moment.MomentInput
            salesAdminSignOutTime: moment.MomentInput
          }) => ({
            ...item,
            salesAdminSignInTime:
              item.salesAdminSignInTime != null
                ? moment.utc(item.salesAdminSignInTime).local().format(timeFormat)
                : '-',
            salesAdminSignOutTime:
              item.salesAdminSignOutTime != null
                ? moment.utc(item.salesAdminSignOutTime).local().format(timeFormat)
                : '-',
            isActive: item?.isActive ? 'Active' : 'Inactive',
          })
        )
      )
    },
    onError: (err) => console.log('error', err),
  })

  useEffect(() => {
    setFilterOptions((prevOptions: any) => {
      return { ...prevOptions, page: pageNo + 1 }
    })
  }, [pageNo])

  const handleSearch = (searchValue: any) => {
    updatePageNo(0)
    setFilterOptions((prevOptions: any) => {
      return { ...prevOptions, searchText: searchValue, page: pageNo + 1 }
    })
  }

  const openEditSales = (e: any, editId: any) => {
    navigate(`/${getUrlParams.adminUser}/sales-channel-list/edit-salesChannel`, {
      state: { isSolarProduct: isSolarProduct },
    })

    localStorage.setItem('salesEditId', editId)
  }

  useEffect(() => {
    const { page, perPage, ...rest } = filterOptions
    setFilterTempOptions(rest)
  }, [])

  const csvDownloadFun = async () => {
    await getQcCSVListByTeamAdmin()
    if (csvRef.current) {
      csvRef.current.link.click()
    }
  }

  // Delete

  const [deleteSalesChannel] = useMutation(DELETE_SALES_CHANNELS, {
    variables: {
      salesChannelIds: removeScId,
    },
    onCompleted: (data) => {
      MySwal.fire({
        title: `${data.deleteSalesChannels[0].message}`,
        icon: 'success',
        confirmButtonColor: '#3E97FF',
      })
      refetch()
    },
    onError: (err) => alert(err.message, 'error'),
  })

  const removeSalesChannel = async (id: any) => {
    setRemoveScId(id)
    MySwal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this",
      iconHtml: `<img src=${SwalThinkingImage}>`,
      customClass: {
        icon: 'no-border',
      },
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it',
      confirmButtonColor: '#3E97FF',
      cancelButtonText: 'No, cancel !',
      cancelButtonColor: 'rgb(39 37 37 / 52%)',
      reverseButtons: true,
    }).then(function (result) {
      if (result.value) {
        deleteSalesChannel()
        // alert display
      }
    })
  }

  // Audit
  const handleOpenAuditModal = (salesChannelId: any) => {
    navigate(`/${getUrlParams.adminUser}/saleschannel-audit`, {
      state: {
        itemId: salesChannelId,
        itemType: 'SalesChannel',
      },
    })
  }

  // Activate / Inactivate
  const confirmTitle = 'Are you sure?'
  const cancelText = 'No, cancel !'
  const cancelBtnClr = 'rgb(39 37 37 / 52%)'
  const salesChannelActivate = (e: any, id: any, activeValue: any) => {
    e.preventDefault()
    setActivate((prevOptions: any) => {
      return { ...prevOptions, id, isActive: activeValue }
    })

    if (activeValue) {
      MySwal.fire({
        title: confirmTitle,
        iconHtml: `<img src=${SwalThinkingImage}>`,
        customClass: {
          icon: 'no-border',
        },
        showCancelButton: true,
        confirmButtonText: 'Yes, Activate it',
        confirmButtonColor: '#3E97FF',
        cancelButtonText: cancelText,
        cancelButtonColor: cancelBtnClr,
        reverseButtons: true,
      }).then(salesChannelAction)
    } else {
      MySwal.fire({
        title: confirmTitle,
        iconHtml: `<img src=${SwalThinkingImage}>`,
        customClass: {
          icon: 'no-border',
        },
        showCancelButton: true,
        confirmButtonText: 'Yes, Inactivate it',
        confirmButtonColor: '#3E97FF',
        cancelButtonText: cancelText,
        cancelButtonColor: cancelBtnClr,
        reverseButtons: true,
      }).then(salesChannelAction)
    }
  }

  const [updateSalesChannelStatus] = useMutation(UPDATE_SALES_CHANNEL_STATUS, {
    variables: {
      id: activate.id,
      isActive: activate.isActive,
    },
    onCompleted: (data) => {
      refetch()
    },
  })
  const salesChannelAction = (result: any) => {
    if (result.value) {
      updateSalesChannelStatus()
      MySwal.fire({
        title: 'Success!',
        text: 'Sales channel status updated successfully',
        icon: 'success',
        confirmButtonColor: '#3E97FF',
      })
    }
  }
  return (
    <>
      <div
        className='d-flex flex-row justify-content-between'
        style={{ height: '48px', marginBottom: '20px' }}
      >
        <div className='d-flex flex-column'>
          <span className='fs-3 fw-bold text-gray-900'>Sales Channel List</span>
          <span className='text-gray-500 fw-semibold lh-20px fs-7'>Home - Sales Channels</span>
        </div>
      </div>

      <KTCard>
        <div className='card card-custom' data-testid='card-custom'>
          <div className='card-header card-body border-0 d-flex justify-content-center align-items-center'>
            <div className='card-title'>
              <div className='d-flex align-items-center position-relative my-1'>
                <SearchComponent handleSearch={handleSearch} placeholder='Search sales channels' />
              </div>
            </div>
            <div
              className='card-toolbar flex-row-fluid justify-content-end gap-5'
              data-testid='card-toolbar'
            >
              <div className='m-0'>
                {total !== 0 && (
                  <DownloadCsv
                    csvDownloadFun={csvDownloadFun}
                    reload={reload}
                    csvHeaders={csvHeaders}
                    csvRef={csvRef}
                    downloadData={downloadData}
                    downloadFileName='SalesChannel.csv'
                  />
                )}

                <button className='btn btn-primary fs-6 ms-4' onClick={(e) => openModal(e, '')}>
                  <img src={plusIcon} alt='' className='svg-icon svg-icon-1' />
                  <span>Add Sales Channel</span>
                </button>
              </div>
              <CreateSalesChannelModal
                show={showCreateAppModal}
                handleClose={handleCloseModal}
                refetchList={refreshCustomerList}
                method={createModal}
                editId={salesChannelId}
              />
            </div>
          </div>

          <KTCardBody className='px-9 py-0 min-h-400px' scroll>
            {total !== 0 ? (
              <div className='table-responsive-xxl'>
                {loading ? (
                  <div className='text-center'>
                    <Spinner animation='border' className='text-gray-600 text-center' role='status'>
                      <span className='visually-hidden'>Loading...</span>
                    </Spinner>
                  </div>
                ) : (
                  <table className='table table-row-dashed table-row-gray-200 align-middle gs-0 gy-4'>
                    <thead>
                      <tr className='fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200'>
                        <th className='header_title'>Channel Name</th>
                        <th className='header_title'>Admin Email ID</th>
                        <th className='header_title'>Rep Id</th>
                        <th className='header_title'># Products Assigned</th>
                        <th className='header_title'># Agents</th>
                        <th className='header_title'>Sign In / Out Time</th>
                        <th className='header_title'>Status</th>
                        <th className='header_title'></th>
                      </tr>
                    </thead>
                    <tbody>
                      {salesChannel &&
                        salesChannel.map((item: any) => {
                          return (
                            <tr className='border-bottom-2' key={item.salesChannelId}>
                              <td
                                className='name cursor-pointer'
                                onClick={(e) => openEditSales(e, item.salesChannelId)}
                              >
                                {item.salesChannelName}
                              </td>
                              <td
                                className='content cursor-pointer'
                                onClick={(e) => openEditSales(e, item.salesChannelId)}
                              >
                                {item.salesAdminEmailId}
                              </td>
                              <td
                                className='name cursor-pointer'
                                onClick={(e) => openEditSales(e, item.salesChannelId)}
                              >
                                {item.salesChannelRepId}
                              </td>
                              <td
                                className='content cursor-pointer'
                                onClick={(e) => openEditSales(e, item.salesChannelId)}
                              >
                                {item.noOfProductsAssigned}
                              </td>
                              <td
                                className='content cursor-pointer'
                                onClick={(e) => openEditSales(e, item.salesChannelId)}
                              >
                                {item.noOfAgents}
                              </td>
                              <td
                                className='content cursor-pointer'
                                onClick={(e) => openEditSales(e, item.salesChannelId)}
                              >
                                {item.salesAdminSignInTime ? (
                                  <div style={{ whiteSpace: 'nowrap' }}>
                                    {`${moment
                                      .utc(item.salesAdminSignInTime)
                                      .local()
                                      .format(timeFormat)} /`}
                                  </div>
                                ) : (
                                  '- /'
                                )}
                                {item.salesAdminSignOutTime
                                  ? ` ${moment
                                    .utc(item.salesAdminSignOutTime)
                                    .local()
                                    .format(timeFormat)}`
                                  : '-'}
                              </td>
                              <td className={item?.isActive ? 'text-success' : 'text-danger'}>
                                {item?.isActive ? 'Active' : 'Inactive'}
                              </td>
                              <td className='content'>
                                <Dropdown className='show-override' key={item.salesChannelId}>
                                  <Dropdown.Toggle
                                    id='dropdown-custom-1'
                                    className='text-gray-600 btn btn-sm btn-icon btn-active-light-primary btn-light-primary btn-arrow-overide'
                                    style={{ background: 'none!important' }}
                                  >
                                    <i className='bi bi-three-dots-vertical fs-7 text-primary'></i>
                                  </Dropdown.Toggle>
                                  <Dropdown.Menu className='py-2 menu-state-bg-primary'>
                                    <Dropdown.Item
                                      as='div'
                                      className='text-gray-600 fs-7 menu-item p-0'
                                    >
                                      <div
                                        className='menu-link'
                                        onClick={(e) => openEditSales(e, item.salesChannelId)}
                                      >
                                        Edit
                                      </div>
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                      as='div'
                                      className='text-gray-600 fs-7 menu-item p-0'
                                    >
                                      <div
                                        className='menu-link'
                                        onClick={(e) => {
                                          item.isActive
                                            ? salesChannelActivate(e, item.salesChannelId, false)
                                            : salesChannelActivate(e, item.salesChannelId, true)
                                        }}
                                      >
                                        {item.isActive ? 'Inactivate' : 'Activate'}
                                      </div>
                                    </Dropdown.Item>

                                    <Dropdown.Item
                                      as='div'
                                      className='text-gray-600 fs-7 menu-item p-0'
                                    >
                                      <div
                                        className='menu-link text-danger text-hover-white'
                                        onClick={() => removeSalesChannel(item.salesChannelId)}
                                      >
                                        Delete
                                      </div>
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                      as='div'
                                      className='text-gray-600 fs-7 menu-item p-0'
                                    >
                                      <div
                                        className='menu-link'
                                        onClick={(e) => handleOpenAuditModal(item?.salesChannelId)}
                                      >
                                        Audit
                                      </div>
                                    </Dropdown.Item>
                                  </Dropdown.Menu>
                                </Dropdown>
                              </td>
                            </tr>
                          )
                        })}
                    </tbody>
                  </table>
                )}
              </div>
            ) : (
              <div className='fs-4 fw-semibold text-center text-muted min-h-400px d-flex-align-items-center justify-content-center'>
                No Results Found
              </div>
            )}
          </KTCardBody>

          {total !== 0 ? (
            <div className='card-footer border-0'>
              <UsersListPagination
                page={pageNo}
                total={total}
                updatePage={updatePageNo}
                recordsPerPage={(e: any) => {
                  updateRowsPerPage(parseInt(e))
                }}
                rowsPerPage={filterOptions.perPage}
              />
            </div>
          ) : (
            <></>
          )}
        </div>
      </KTCard>
    </>
  )
}

export { SalesChannelList }
